import styled from 'styled-components';
import { breakpoints, css } from '../../styles/theme';
import SummaryPriceDetails, { WIDTH_OF_OPTION_CARD } from './SummaryOptionsTemplate';
import { rem } from 'polished';

export const SummaryOptionsStyled = styled(SummaryPriceDetails)`
    margin: ${rem(30)} 0 ${rem(-10)} 0;
    padding: 0 ${rem(10)};

    @media screen and (min-width: ${breakpoints.sm}px) {
        margin: ${rem(30)} ${rem(10)} ${rem(-10)} ${rem(10)};
        padding: 0;
    }

    .updatingWrapper {
        position: absolute;
        top: 45%;
        left: 50%;
    }

    .titleWrapperButton {
        width: 100%;
    }

    .titleWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem(20)} 0 0 0;
        width: 100%;

        .title {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: 1.4;
        }

        svg {
            height: ${rem(16)};
        }

        .isOpen {
            svg {
                height: ${rem(14)};

                path {
                    stroke-width: 2;
                }
            }
        }
    }

    .descriptionWrapper {
        margin-top: ${rem(20)};
    }

    .loadingWrapper {
        height: ${rem(100)};
        display: flex;
        justify-content: center;
        align-items: center;
    }
  
    .noOptionsWrapper {
        text-align: center;
        padding: ${rem(20)} 0;
    }

    .optionsWrapper {
        position: relative;

        &.isLoading {
            .options,
            .left-blurry,
            .right-blurry,
            .next-btn,
            .back-btn {
                opacity: 0.4;
            }
        }

        .options {
            display: flex;
            flex-direction: row;
            gap: ${rem(20)};

            .option-card {
                min-width: ${rem(WIDTH_OF_OPTION_CARD)};
                width: ${rem(WIDTH_OF_OPTION_CARD)};
            }
        }

        .left-blurry,
        .right-blurry {
            height: 100%;
            width: ${rem(30)};
            position: absolute;
            filter: blur(5px);
            background: ${({ theme }) => theme.colors.white};
            z-index: 999999;
            top: 0;
        }

        .left-blurry {
            left: ${rem(-20)};

            @media screen and (min-width: ${breakpoints.sm}px) {
                left: ${rem(-20)};
            }
        }

        .right-blurry {
            right: ${rem(-20)};

            @media screen and (min-width: ${breakpoints.sm}px) {
                right: ${rem(-10)};
            }
        }

        .next-btn,
        .back-btn {
            background: none;
            border: 2px solid;
            border-radius: ${rem(10)};
            width: ${rem(43)};
            height: ${rem(43)};
            display: flex;
            background: white;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            position: absolute;
            z-index: 999999999;
            top: calc(50% - 20px);

            &:focus-visible {
                box-shadow: none;
                outline: none;
            }

            svg {
                stroke: ${({ theme }) => theme.colors.white};
            }
        }

        .next-btn {
            right: ${rem(10)};

            svg {
                transform: rotate(180deg);
            }
        }

        .back-btn {
            left: ${rem(10)};
        }
    }
`;
